import { KatAlert, KatDropdown, KatSpinner } from '@amzn/katal-react';
import React, { useContext, useState } from 'react';
import { SelfServiceLayout } from 'src/self-service/components/SelfServiceLayout';
import { AuthContext } from 'src/state/providers/AuthProvider';
import {
  IGetUsersForAccountRequest,
  ResourceAttributes,
} from 'src/state/slice/models/CaseLifecycleTypes';
import { useGetUsersFromAccountQuery } from 'src/state/slice/umsServiceApi';
import { ListUserTable } from './ListUserTable';
import Spacer from 'src/components/Layout/Spacer';
import { LIST_USER_PAGE } from 'src/self-service/constants/SelfServiceConstants';
import { fetchAPIErrorMessage } from 'src/state/slice/utils/apiUtils';
import styled from 'styled-components';

export interface UserDetailsTable {
  userId: string;
  name: string;
  emailId: string;
  isInternalUser: boolean;
  role: string;
}

export const ListUserSection = styled.div`
  font-size: 14px;
`;
export const ListUser = () => {
  const { accountAttributes, clientId, preferredAccountId } =
    useContext(AuthContext);
  const [accountId, setAccountId] = useState(preferredAccountId);

  const request: IGetUsersForAccountRequest = {
    accountType: 'LENS-UMS-Account',
    accountId: accountId,
    clientId: clientId,
    pageSize: 300,
  };

  const { isLoading, isFetching, isError, data, error, isSuccess } =
    useGetUsersFromAccountQuery(request);

  const optionList = accountAttributes
    .map((accountAttributes: ResourceAttributes) => {
      return {
        name: accountAttributes.attributes.accountName,
        value: accountAttributes.id,
      };
    })
    .sort((firstElement, secondElement) =>
      firstElement.name.localeCompare(secondElement.name, 'en'),
    );

  return (
    <ListUserSection>
      {isError && (
        <KatAlert
          variant="danger"
          description={fetchAPIErrorMessage(
            error,
            `Unable to fetch users for account: ${accountId}`,
          )}
        ></KatAlert>
      )}
      <SelfServiceLayout
        header={LIST_USER_PAGE.PAGE_HEADER}
        body={
          <>
            <KatDropdown
              label={LIST_USER_PAGE.ACCOUNT_ID_FIELD_NAME}
              onChange={(e: KatDropdown.ChangeEvent) =>
                setAccountId(e.detail.value)
              }
              options={optionList}
              value={accountId}
              searchable
            ></KatDropdown>
            <Spacer height="1rem" />
            {(isFetching || isLoading) && <KatSpinner />}
            {!isError && !isFetching && !isError && (
              <ListUserTable data={data} accountId={accountId} />
            )}
          </>
        }
      ></SelfServiceLayout>
    </ListUserSection>
  );
};
